import Swiper, {Navigation, Scrollbar} from "swiper";

const Slider = (element: HTMLElement) =>
	new Swiper(element, {
		modules: [Navigation, Scrollbar],
		spaceBetween: 48,
		slidesPerView: 1,
		breakpoints: {
			900: {
				slidesPerView: 3,
			}
		},
		centerInsufficientSlides: true,
		navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev",
		},
		scrollbar: {
			el: ".swiper-scrollbar",
			draggable: true,
		},
	});

export default () => {
	const sliders: HTMLElement[] = Array.from(
		document.querySelectorAll(".block.related .slider")
	);

	if (!sliders) return;

	sliders.map((element: HTMLElement) => Slider(element));
};
